import type { CompConfigResponse, UpdateCompConfigRequest } from '@jq4race/shared';

import { request } from './client.js';

export async function getLocationCompConfig(locationId: string): Promise<CompConfigResponse> {
  return request<CompConfigResponse>(
    `/admin/locations/${encodeURIComponent(locationId)}/comp-config`,
    { method: 'GET' },
  );
}

export async function updateLocationCompConfig(
  locationId: string,
  input: UpdateCompConfigRequest,
): Promise<CompConfigResponse> {
  return request<CompConfigResponse>(
    `/admin/locations/${encodeURIComponent(locationId)}/comp-config`,
    { method: 'PUT', body: input },
  );
}
